import { BalanceContext } from '@/contexts/BalanceContext';
import { GlobalUserDataContext } from '@/contexts/GlobalUserDataContext';
import { MultiBetLiveContext } from '@/contexts/MultiBetLiveContext';
import { TableInfoContext } from '@/contexts/TableInfoContext';
import { WebSocketContext } from '@/contexts/WebSocketContext';
import { CMDBet } from '@/models/cmd/live/CMDBet';
import { CMDPsBet } from '@/models/cmd/live/CMDPsBet';
import { CMDPsRoomSeat } from '@/models/cmd/live/CMDPsRoomSeat';
import { Bet } from '@/models/host/BetAmount';
import {
    getTableBetByHostId,
    tableBetSliceActions,
} from '@/modules/betTable/slice';
import { getLiveDataState } from '@/modules/main/slice/liveData';
import { useContext, useEffect, useRef } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { AudioPlayContext } from '../contexts/AudioPlayContext';
import { BetChipContext } from '../contexts/BetChipContext';
import { StateMsgType } from '../models/Popup';
import { GameType as GameTypeEnum } from '../models/games/enums/GameType';
import { inGamePopupSliceActions } from '../modules/popup/inGameSlice';
import {
    isOppositeBetting as andarbaharIsOppositeBetting,
    getAndarBaharCurrentTotal,
    getAndarBaharHedgeBettingBets,
    getShareLimitBetTypes as getAndarBaharShareLimitBetTypes,
} from '../modules/rwdGame/andarbahar/utils';
import {
    isOppositeBetting as baccaratIsOppositeBetting,
    getBaccaratCurrentTotal,
    getBaccaratHedgeBettingBets,
    getShareLimitBetTypes as getBaccaratShareLimitBetTypes,
} from '../modules/rwdGame/baccarat/utils';
import { isOppositeBetting as dragonTigerIsOppositeBetting } from '../modules/rwdGame/dragonTiger/utils';
import { isOppositeBetting as rouletteIsOppositeBetting } from '../modules/rwdGame/roulette/utils';
import {
    getSeDieCurrentTotal,
    getSeDieHedgeBettingBets,
    isOppositeBetting as sedieIsOppositeBetting,
} from '../modules/rwdGame/sedie/utils';
import { isOppositeBetting as sicboIsOppositeBetting } from '../modules/rwdGame/sicbo/utils';
import {
    getTeenPatti2020HedgeBettingBets,
    getTeenPattiCurrentTotal,
    isOppositeBetting as teenpattiIsOppositeBetting,
} from '../modules/rwdGame/teenpatti/utils';
import { isOppositeBetting as thaiHiLoIsOppositeBetting } from '../modules/rwdGame/thaiHiLo/utils';
import { isOppositeBetting as ultraRouletteIsOppositeBetting } from '../modules/rwdGame/ultraRoulette/utils';
import { RootState } from '../store/store';
import { checkBetsAvailed } from '../utils/commonFunc';
// import { useBetSource } from './useBetSource';
export const useNBSBet = (hostId: number) => {
    const { sendCommand } = useContext(WebSocketContext);
    const { MaxBet, GameType, betSource, isMultiBet } =
        useContext(TableInfoContext);
    const {
        GameId,
        BetsSummary,
        PendingBets,
        ConfirmedBets,
        isBetConfirmed,
        isWaitingBet,
        doConfirm,
        doCancel,
        PlayerBets,
        BetSeqId,
    } = useSelector((state: RootState) => getTableBetByHostId(state, hostId));
    const { balance, balanceSummary } = useContext(BalanceContext);
    // const [unconfirmedTotalBet, setUnconfirmedTotalBet] = useState<number>(0);
    // const { BetFormat } = useSelector(getMainUserState);
    const { isHedgeBettingEnabled, isAutoConfirm } = useContext(
        GlobalUserDataContext
    );
    // const isAutoConfirm = useMemo(() => {
    //     console.log('????', isAutoConfirmEnabled);
    //     return true;
    // }, [isAutoConfirmEnabled]);

    const { totalHostsBetInfo } = useSelector(getLiveDataState);
    const dispatch = useDispatch();
    const { playChipBetAudio } = useContext(AudioPlayContext);
    const { setPendingBetState } = useContext(MultiBetLiveContext);
    const { selectedBetRule } = useContext(BetChipContext);

    const unconfirmedTotalBet = useRef<number>(0);
    const unconfirmedTotalBetWithHold = useRef<number>(0);
    const avaibleBalance = useRef<number>(0);
    // useEffect(() => {
    //     if (isAutoConfirmEnabled) {
    //         setUnconfirmedTotalBet(TableTotalBet);
    //     } else {
    //         setUnconfirmedTotalBet(PendingTotalBet);
    //     }
    // }, [TableTotalBet, PendingTotalBet]);
    useEffect(() => {
        if (totalHostsBetInfo) {
            unconfirmedTotalBet.current = totalHostsBetInfo.pendingBetAmount;
            unconfirmedTotalBetWithHold.current =
                totalHostsBetInfo.pendingWithHoldAmount;
        }
        avaibleBalance.current = balance ? balance : 0;
    }, [totalHostsBetInfo, isAutoConfirm]);
    useEffect(() => {
        if (isAutoConfirm) {
            unconfirmedTotalBet.current = 0;
            unconfirmedTotalBetWithHold.current = 0;
        } else {
            if (totalHostsBetInfo) {
                unconfirmedTotalBet.current =
                    totalHostsBetInfo.pendingBetAmount;
                unconfirmedTotalBetWithHold.current =
                    totalHostsBetInfo.pendingWithHoldAmount;
            } else {
                unconfirmedTotalBet.current = 0;
                unconfirmedTotalBetWithHold.current = 0;
            }
        }
        avaibleBalance.current = balance ? balance : 0;
    }, [balance]);
    useEffect(() => {
        //only non-ABC clear pending state in multibet
        if (!isWaitingBet) {
            if (setPendingBetState) setPendingBetState(hostId, false);
        }
    }, [isWaitingBet]);
    useEffect(() => {
        if (doConfirm) {
            //Multibet
            const seatCMD = new CMDPsRoomSeat();
            seatCMD.HostID = hostId;
            seatCMD.Seat = 100; //stand
            seatCMD.IsMultiBet = 1;
            sendCommand(seatCMD);

            _doConfirmBet(GameId);
            dispatch(
                tableBetSliceActions.doConfirmBets({
                    hostId: hostId,
                    gameId: 0,
                    value: false,
                })
            );
        }
    }, [doConfirm]);
    useEffect(() => {
        if (doCancel) {
            _doCancelBet(GameId);
            dispatch(
                tableBetSliceActions.doCancelBets({
                    hostId: hostId,
                    gameId: 0,
                    value: false,
                })
            );
        }
    }, [doCancel]);

    const _doCancelBet = (gameId: number) => {
        dispatch(
            tableBetSliceActions.clearPendingBets({
                hostId: hostId,
                gameId: gameId,
                betSeqId: isAutoConfirm ? BetSeqId + 1 : undefined,
                startGame: false,
            })
        );
        if (setPendingBetState) setPendingBetState(hostId, false);
    };
    const _doConfirmBet = (gameId: number): boolean => {
        if (isAutoConfirm) return false;
        if (!selectedBetRule) return false;

        const cmd = new CMDPsBet();
        cmd.gameID = gameId;
        cmd.BetSource = betSource;
        let belowBetLimit = false;
        let isValidBet = false;
        for (let i = 0; i < PendingBets.length; i++) {
            if (PendingBets[i]) {
                let cmdBet = new CMDBet();
                cmdBet.betType = i;
                cmdBet.betAmount = PendingBets[i];
                if (cmdBet.betAmount < selectedBetRule.MinBet) {
                    belowBetLimit = true;
                    if (isMultiBet) {
                        belowBetLimit = false;
                    } else if (ConfirmedBets && ConfirmedBets[cmdBet.betType]) {
                        belowBetLimit = false;
                    }
                }
                cmd.bets.push(cmdBet);
            }
        }

        if (belowBetLimit) {
            // dispatch(
            //     inGamePopupSliceActions.open(
            //         'system.bet_below_win_bet',
            //         GameType,
            //         StateMsgType.betInfo_Fail,
            //         gameId
            //     )
            // );
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: hostId,
                        isOpen: true,
                    })
                );
                dispatch(
                    inGamePopupSliceActions.updateDataSet({
                        hostId: hostId,
                        key: 'system.bet_below_win_bet',
                        gameType: GameType,
                        stateMsgType: StateMsgType.betInfo_Fail,
                        gameId: gameId,
                    })
                );
            });
        } else {
            isValidBet = true;
            sendCommand(cmd);
            batch(() => {
                dispatch(
                    tableBetSliceActions.setWaitingBetResult({
                        hostId: hostId,
                        gameId: gameId,
                        value: true,
                    })
                );
                // dispatch(gameSliceActions.setWaitingBetResult(true));
            });
        }
        return isValidBet;
    };

    const _doUndoBet = (gameId: number) => {
        // if (!isAutoConfirmEnabled) return;
        const undo =
            PlayerBets && PlayerBets.length > 0
                ? PlayerBets[PlayerBets.length - 1].bets
                : undefined;

        if (undo) {
            dispatch(
                tableBetSliceActions.undoBet({
                    hostId: hostId,
                    gameId: gameId,
                    bets: undo,
                })
            );
        }
    };
    const _doPendingBet = (bet: Bet) => {
        if (isAutoConfirm && isBetConfirmed) {
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: hostId,
                        isOpen: true,
                    })
                );
                dispatch(
                    inGamePopupSliceActions.updateDataSet({
                        hostId: hostId,
                        key: 'abc.betconfirm_mode_invalid',
                        gameType: GameType,
                        stateMsgType: StateMsgType.betInfo_Fail,
                        gameId: bet.GameId,
                    })
                );
            });
            return;
        }
        if (bet && !isHedgeBettingEnabled && isOppositeBetting(bet.Type)) {
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: hostId,
                        isOpen: true,
                    })
                );
                dispatch(
                    inGamePopupSliceActions.updateDataSet({
                        hostId: hostId,
                        key: 'system.bet_opposite',
                        gameType: GameType,
                        stateMsgType: StateMsgType.betInfo_Fail,
                        gameId: bet.GameId,
                    })
                );
            });
            return;
        }

        if (!avaibleBalance.current || avaibleBalance.current < 1) {
            if (balance !== undefined) {
                batch(() => {
                    dispatch(
                        inGamePopupSliceActions.updateIsOpen({
                            hostId: hostId,
                            isOpen: true,
                        })
                    );
                    dispatch(
                        inGamePopupSliceActions.updateDataSet({
                            hostId: hostId,
                            key: 'system.not_enough_money',
                            gameType: GameType,
                            stateMsgType: StateMsgType.betInfo_Fail,
                            gameId: bet.GameId,
                        })
                    );
                });
            }
            return;
        }

        const availableBets = checkBetsAvailed({
            hostId: hostId,
            gameType: GameType,
            bets: [bet],
            amountOverBetLimit: amountOverBetLimit,
            totalPendingBetAmount: unconfirmedTotalBet.current,
            totalPendingWithHoldAmount: unconfirmedTotalBetWithHold.current,
            availableBalance: avaibleBalance.current,
        });

        if (availableBets.isNotEnoughMoney) {
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: hostId,
                        isOpen: true,
                    })
                );
                dispatch(
                    inGamePopupSliceActions.updateDataSet({
                        hostId: hostId,
                        key: 'system.not_enough_money',
                        gameType: GameType,
                        stateMsgType: StateMsgType.betInfo_Fail,
                        gameId: bet.GameId,
                    })
                );
            });
        } else if (availableBets.isOutOfBetLimit) {
            batch(() => {
                dispatch(
                    inGamePopupSliceActions.updateIsOpen({
                        hostId: hostId,
                        isOpen: true,
                    })
                );
                dispatch(
                    inGamePopupSliceActions.updateDataSet({
                        hostId: hostId,
                        key: 'system.bet_out_of_limit_red',
                        gameType: GameType,
                        stateMsgType: StateMsgType.betInfo_Fail,
                        gameId: bet.GameId,
                    })
                );
            });
        } else {
            batch(() => {
                if (availableBets.haveDisabledBetType) {
                    dispatch(
                        inGamePopupSliceActions.updateIsOpen({
                            hostId: hostId,
                            isOpen: true,
                        })
                    );
                    dispatch(
                        inGamePopupSliceActions.updateDataSet({
                            hostId: hostId,
                            key: 'system.have_cannot_rebet_zone',
                            gameType: GameType,
                            stateMsgType: StateMsgType.betInfo_Warning,
                            gameId: bet.GameId,
                        })
                    );
                } else if (
                    availableBets.haveBetLimitAllIn &&
                    !availableBets.isAllIn
                ) {
                    dispatch(
                        inGamePopupSliceActions.updateIsOpen({
                            hostId: hostId,
                            isOpen: true,
                        })
                    );
                    dispatch(
                        inGamePopupSliceActions.updateDataSet({
                            hostId: hostId,
                            key: 'system.bet_exceed_limit_allin',
                            gameType: GameType,
                            stateMsgType: StateMsgType.betInfo_Warning,
                            gameId: bet.GameId,
                        })
                    );
                } else if (availableBets.isAllIn) {
                    dispatch(
                        inGamePopupSliceActions.updateIsOpen({
                            hostId: hostId,
                            isOpen: true,
                        })
                    );
                    dispatch(
                        inGamePopupSliceActions.updateDataSet({
                            hostId: hostId,
                            key: 'system.all_in',
                            gameType: GameType,
                            stateMsgType: StateMsgType.betInfo_Warning,
                            gameId: bet.GameId,
                        })
                    );
                }
                // if (isMultiBet) {
                //     setCurrentTable(hostId);
                // }
                // dispatch(gameSliceActions.onPendingBet(availableBets.bets[0]));

                dispatch(
                    tableBetSliceActions.addBet({
                        hostId: hostId,
                        gameId: bet.GameId,
                        bets: availableBets.bets,
                    })
                );
                if (setPendingBetState) setPendingBetState(hostId, true);

                // console.log(playChipBetAudio);
                playChipBetAudio();
            });
        }
    };

    const getShareLimitBetTypesByGameType = (betType: number): number[] => {
        switch (GameType) {
            case GameTypeEnum.Baccarat:
                return getBaccaratShareLimitBetTypes(betType);
            case GameTypeEnum.AndarBahar:
                return getAndarBaharShareLimitBetTypes(betType);
        }
        return [betType];
    };

    const getHedgeBettingBets = (bets: Array<Bet>) => {
        const newBets = new Array<Bet>();
        switch (GameType) {
            case GameTypeEnum.Baccarat:
                return getBaccaratHedgeBettingBets(bets);
            case GameTypeEnum.SeDie:
                return getSeDieHedgeBettingBets(bets);
            case GameTypeEnum.AndarBahar:
                return getAndarBaharHedgeBettingBets(bets);
            case GameTypeEnum.TeenPatti2020:
                return getTeenPatti2020HedgeBettingBets(bets);
            default:
                newBets.push(...bets);
        }
        return newBets;
    };

    const getCurrentTotal = (betType: number): number => {
        const finalBet = isAutoConfirm ? [] : ConfirmedBets;
        switch (GameType) {
            case GameTypeEnum.Baccarat:
                return getBaccaratCurrentTotal(betType, BetsSummary, finalBet);
            case GameTypeEnum.AndarBahar:
                return getAndarBaharCurrentTotal(
                    betType,
                    BetsSummary,
                    finalBet
                );
            case GameTypeEnum.SeDie:
                return getSeDieCurrentTotal(betType, BetsSummary, finalBet);
            case GameTypeEnum.TeenPatti2020:
                return getTeenPattiCurrentTotal(betType, BetsSummary, finalBet);
        }
        let amount = 0;
        const matchBetTypes = getShareLimitBetTypesByGameType(betType);
        for (let i = 0; i < matchBetTypes.length; i++) {
            if (BetsSummary[matchBetTypes[i]]) {
                amount += BetsSummary[matchBetTypes[i]];
            }
            if (finalBet[matchBetTypes[i]]) {
                amount += finalBet[matchBetTypes[i]];
            }
        }
        return amount;
    };

    const amountOverBetLimit = (
        betType: number,
        chipAmount: number
    ): number => {
        const current = getCurrentTotal(betType); // BetsSummary[betType] ? BetsSummary[betType] : 0;
        const maxBet = MaxBet?.find(
            mb => Number(mb.BetType) === Number(betType)
        );
        switch (GameType) {
            // case GameTypeEnum.Baccarat:
            // case GameTypeEnum.AndarBahar:
            //     //TODO
            //     return chipAmount + current;
            default:
                if (maxBet) {
                    return chipAmount + current - maxBet.MaxBet;
                } else {
                    return chipAmount + current;
                }
        }
    };

    const isOppositeBetting = (betType: number): boolean => {
        // TODO: add other game checking
        switch (GameType) {
            case GameTypeEnum.Baccarat:
                return baccaratIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.SeDie:
                return sedieIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.SicBo:
                return sicboIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.Dragon:
                return dragonTigerIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.TeenPatti2020:
                return teenpattiIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.AndarBahar:
                return andarbaharIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.Roulette:
                return rouletteIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.UltraRoulette:
                return ultraRouletteIsOppositeBetting(betType, BetsSummary);
            case GameTypeEnum.ThaiHiLo:
                return thaiHiLoIsOppositeBetting(betType, BetsSummary);
            default:
                return false;
        }
    };

    return {
        avaibleBalance,
        balanceSummary,
        ConfirmedBets,
        isHedgeBettingEnabled,
        isAutoConfirm,
        isBetConfirmed,
        _doPendingBet,
        _doConfirmBet,
        _doUndoBet,
        _doCancelBet,
        getCurrentTotal,
        amountOverBetLimit,
        getHedgeBettingBets,
    };
};
export type useNBSBetState = ReturnType<typeof useNBSBet>;
